import React, { ReactNode } from 'react';

import { styled } from '@linaria/react';
import Bullet from '@components/Bullet';

export interface BulletListProps {
  variant?: 'default' | 'success' | 'error' | 'alphabet' | 'roman';
  bottomMargin?: 'default' | 'big' | 'small';
  theme?: any;
  children?: React.ReactNode;
  margin: string | number;
}

const OuterContainer = styled.div<BulletListProps>`
  display: block;
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
  padding: 0;
  position: relative;
`;

function BulletList({
  variant,
  children,
  bottomMargin,
  margin,
  ...props
}: BulletListProps) {

  const alpahbet = 'abcdefghijklmnopqrstuvwxyz'.split('');
  let alpahbetIndex = -1;
  let romanIndex = 0;

  function convertToRoman(num: number) {
    var roman: any = {
      m: 1000,
      cm: 900,
      d: 500,
      cd: 400,
      c: 100,
      xc: 90,
      l: 50,
      xl: 40,
      x: 10,
      ix: 9,
      v: 5,
      iv: 4,
      i: 1
    };
    var str = '';
    for (var i of Object.keys(roman)) {
      var q = Math.floor(num / roman[i]);
      num -= q * roman[i];
      str += i.repeat(q);
    }
    return str;
  }

  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child) && child.type === Bullet) {
      alpahbetIndex++;
      romanIndex++;
      return React.cloneElement(child as React.ReactElement<any>, {
        variant,
        bottomMargin,
        label: variant === 'alphabet' ? alpahbet[alpahbetIndex] : convertToRoman(romanIndex)
        });
    }
    return child;
  });
  return <OuterContainer margin={margin}>{childrenWithProps}</OuterContainer>;
};

BulletList.defaultProps = {
  margin: '0 0 15px'
}

export default BulletList;
